import { useMutation } from '@tanstack/react-query';
import jsPDF from 'jspdf';
import { waitForImagesToLoad } from './images';

interface RenderToPDFOptions {
  element: HTMLDivElement;
}

const printPDF = async ({ element }: RenderToPDFOptions): Promise<void> => {
  const doc = new jsPDF('p', 'mm', 'a4');

  element.style.fontFamily = 'Public Sans, sans-serif';
  element.style.letterSpacing = '0px';
  element.style.wordSpacing = '0px';

  await waitForImagesToLoad(element);

  await doc.html(element, {
    callback: (doc: jsPDF) => {
      const documentAsBlob = doc.output('blob');
      const blobUrl = URL.createObjectURL(documentAsBlob);
      const openDocument = window.open(blobUrl, '_blank');

      // Workaround for Firefox
      setTimeout(() => {
        openDocument?.print();
      }, 100);
    },
    fontFaces: [
      {
        family: 'Public Sans',
        weight: 600,
        src: [
          {
            url: '/static/fonts/PublicSans-SemiBold.ttf',
            format: 'truetype',
          },
        ],
      },
      {
        family: 'Public Sans',
        weight: 500,
        src: [
          {
            url: '/static/fonts/PublicSans-Light.ttf',
            format: 'truetype',
          },
        ],
      },
    ],
    autoPaging: 'slice',
    html2canvas: {
      async: true,
      useCORS: true,
      allowTaint: false,
      imageTimeout: 15000,
    },
    margin: [5, 0, 8, 0],
    width: 211,
    windowWidth: 1000,
  });
};

export const usePrintPDF = () =>
  useMutation<void, Error, RenderToPDFOptions>({
    mutationFn: printPDF,
  });
